import { Patterns } from "../types/template"


export const patterns: Patterns = {
  greenPurple: {
    top: 'green',
    bottom: 'purple'
  },
  purpleGreen: {
    top: 'purple',
    bottom: 'green'
  },
  greyGrey: {
    top: 'grey',
    bottom: 'grey'
  },
  darkGrey: {
    top: 'dark',
    bottom: 'grey'
  },
}